import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useData } from "../../../components/firebase/DataProvider";
import DialogSuccess from "./DialogSuccess";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Gap from "../../../components/Gap";
import AlamatDialog from "../Alamat/AlamatDialog";

function DialogAlamatTersimpan({ open, handleClose, handleCloseDrawer, data }) {
  const { alamat } = useData();
  // console.log(data);
  const handleSubmit = (item) => () => {
    // console.log("alamat",item);
    // setForm({...data,alamat_pengiriman: item})
    const hasil = { product_reward: { ...data }, alamat_pengiriman: item };
    setDialog({
      open: true,
      data: hasil,
    });
  };
  // console.log(form);
  const [dialog, setDialog] = useState({
    open: false,
    data: {},
  });
  const [dialogAlamat, setDialogAlamat] = useState({
    open: false,
    action: "Tambah",
    data: {},
  });

  return (
    <Dialog
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Pilih Alamat</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 10 }}>
        <List>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() =>
              setDialogAlamat({
                open: true,
                action: "Tambah",
                data: {},
              })
            }
            style={{
              textTransform: "capitalize",
            }}
          >
            Tambah Alamat
          </Button>
          <Gap height={20} />
          <Divider style={{ margin: "0px -10px" }} />
          {alamat?.length > 0 ? (
            alamat?.map((item) => {
              return (
                <>
                  <ListItem
                    style={{ padding: "10px 5px" }}
                    button
                    onClick={handleSubmit(item)}
                  >
                    <ListItemText
                      primary={`${item.judul} - ${item.nama_penerima}`}
                      secondary={`${item.alamat_lengkap}, ${item.kecamatan.name}, ${item.kelurahan.name}, ${item.kota.name}`}
                    />
                  </ListItem>
                  <Divider style={{ margin: "0px -10px" }} />
                </>
              );
            })
          ) : (
            <div>
              <p>Tidak ada data</p>
            </div>
          )}
        </List>
      </DialogContent>
      <DialogSuccess
        open={dialog.open}
        handleClose={() => setDialog({ open: false, data: {} })}
        data={dialog.data}
        handleCloseDrawer={handleCloseDrawer}
        handleCloseAlamat={handleClose}
      />
      <AlamatDialog
        open={dialogAlamat.open}
        action={dialogAlamat.action}
        data={dialogAlamat.data}
        handleClose={() =>
          setDialogAlamat({
            open: false,
            action: "Tambah",
            data: {},
          })
        }
      />
    </Dialog>
  );
}

export default DialogAlamatTersimpan;
